import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {BettingPromotionModuleConfig} from "./betting-promotion.module.config";
import {BettingPromotionModuleStore} from "./betting-promotion.module.store";
import {BettingPromotionModuleHandlers} from "./handlers/betting-promotion.module.handlers";

export class BettingPromotionModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, BettingPromotionModuleConfig, BettingPromotionModuleStore, BettingPromotionModuleHandlers];
}
